import { render, staticRenderFns } from "./SubjectNewDialog.vue?vue&type=template&id=5e67052d"
import script from "./SubjectNewDialog.vue?vue&type=script&lang=js"
export * from "./SubjectNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports